<template>
  <div>
    <h2
      class="q-ma-xs"
    >
      Choose Payment Option
    </h2>
    <q-btn
      align="between"
      icon-right="arrow_forward"
      class="full-width q-py-xs text-uppercase text-weight-bolder text-overline"
      style="font-size: 12px; border: 1px solid rgba(0,0,0,0.12);"
      label="Cash"
      @click="$emit('show-cash-options')"
    />
    <q-btn
      v-for="paymentType in paymentTypes.data"
      :key="paymentType.id"
      :label="paymentType.name"
      align="between"
      icon-right="arrow_forward"
      class="full-width"
      @click="() => $emit('pay-with-payment-type', paymentType)"
    />
  </div>
</template>

<script>
export default {
  name: 'OtherPaymentSection',
  configuration: ['paymentTypes'],
  emits: ['show-cash-options', 'pay-with-payment-type']
}
</script>
<style lang="scss" scoped>
h2 {
  color: var(--q-primary);
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1em;
}
</style>
